import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

/** The shell's toast box (extracted from FinishedToast, #1625): a line of text, its actions and Dismiss. */
export default function ShellToast({ testId, inDrawer = false, stacked = false, wrap = false, text, actions, onDismiss }: {
  testId: string; inDrawer?: boolean; stacked?: boolean; text: React.ReactNode;
  /** Let the actions go under the text when the line is too narrow (a long message, a phone). */
  wrap?: boolean;
  actions: Array<{ label: string; onClick: () => void }>; onDismiss: () => void;
}) {
  return <Box data-testid={testId}
    sx={inDrawer ? { px: 1.25, py: 1, borderTop: '1px solid var(--line)' }
      : { position: 'fixed', bottom: stacked ? 76 : 22, left: '50%', transform: 'translateX(-50%)', zIndex: 1400, maxWidth: 'calc(100vw - 32px)' }}>
    <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'var(--ink)', color: 'var(--bg)', pl: 1.75, pr: 1, py: 0.75, borderRadius: '10px', fontSize: 13, boxShadow: inDrawer ? 'none' : 'var(--sh-3)', ...(wrap ? { flexWrap: 'wrap' } : {}) }}>
      <Box component="span" sx={{ minWidth: 0, overflowWrap: 'anywhere', flex: 1, ...(wrap ? { minWidth: 'min(220px, 100%)' } : {}) }}>{text}</Box>
      {actions.map((a) => <Button key={a.label} size="small" onClick={a.onClick} sx={{ color: 'inherit', fontWeight: 600, textDecoration: 'underline', textUnderlineOffset: '2px', flexShrink: 0, minWidth: 0 }}>{a.label}</Button>)}
      <Button size="small" aria-label="Dismiss" onClick={onDismiss} sx={{ color: 'inherit', minWidth: 0, flexShrink: 0 }}>✕</Button>
    </Box>
  </Box>;
}
